import styled from '@emotion/styled/macro';

export const Terms = styled.div`
    font-weight: 400;
    font-size: ${props => props.theme.fontSize.xsmall};
    line-height: 16px;
    text-align: center;
    margin: ${props => props.margin};
`;

export const TermsLink = styled(Terms)`
    text-decoration: underline;
    cursor: pointer;
    color: ${props => props.theme.colours.textDark};
    display: contents;
    text-align: center;
    margin-bottom: 0;

    @media (max-width: ${props => props.theme.widths.containerMaxWidth}) {
        display: block;
    }
`;
